import React from "react";
import Hero from "@insightfulscience/atomic-react/Hero";
import HeroTitle from "@insightfulscience/atomic-react/Hero/Title";
import GuidePageTemplate from "@insightfulscience/atomic-react/GuidePageTemplate";
import GuidePageTemplateMain from "@insightfulscience/atomic-react/GuidePageTemplate/Main";
import {
	PostElementTitleH2,
	PostElementParagraph,
	PostElementOl,
	PostElementListItem,
	PostElementLink,
	PostElementUl,
} from "@insightfulscience/atomic-react/PostElement";
import PageMeta from "@insightfulscience/smart-react/PageMeta";
import { useLocale } from "@insightfulscience/smart-react/i18";
import Html from "@insightfulscience/smart-react/Html";
import SiteLayout from "../../SiteLayout";

const Legal = () => {
	const [t] = useLocale("legal");
	return (
		<SiteLayout>
			<PageMeta title={t("META.TITLE")}>
				<PageMeta.OGP
					locale={t("META.LOCALE")}
					type={t("META.TYPE")}
					title={t("META.TITLE")}
					url={t("META.URL")}
					siteName={t("META.SITE_NAME")}
					articlePublisher={t("META.ARTICLE_PUBLISHER")}
				/>
				<PageMeta.Canonical href={t("META.CANONICAL")} />
				<PageMeta.Twitter
					card={t("META.TWITTER_CARD")}
					title={t("META.TITLE")}
					site={t("META.TWITTER_SITE")}
					creator={t("META.TWITTER_CREATOR")}
				/>
			</PageMeta>
			<Hero color="4" spacing={{ py: 18 }}>
				<HeroTitle>{t("HERO_TITLE")}</HeroTitle>
			</Hero>
			<GuidePageTemplate sidebar={false}>
				<GuidePageTemplateMain sidebar={false}>
					<PostElementTitleH2>{t("COPYRIGHT_NOTICE")}</PostElementTitleH2>
					<PostElementParagraph>{t("COPYRIGHT")}</PostElementParagraph>
					<PostElementParagraph>
						<Html Tag="span">
							{t("NO_PORTION", {
								biomattersLink: "http://www.biomatters.com",
								geneiousLink: "https://www.geneious.com/",
							})}
						</Html>
					</PostElementParagraph>
					<PostElementTitleH2>{t("TRADEMARK_NOTICE")}</PostElementTitleH2>
					<PostElementParagraph>{t("TRADEMARK_NOTICE_TEXT")}</PostElementParagraph>
					<PostElementTitleH2>{t("USE_OF_WEBSITE_TITLE")}</PostElementTitleH2>
					<PostElementParagraph>
						<Html Tag="span">
							{t("USE_OF_WEBSITE_TEXT", {
								biomattersLink: "http://www.biomatters.com",
								geneiousLink: "https://www.geneious.com/",
							})}
						</Html>
					</PostElementParagraph>
					<PostElementTitleH2>{t("TERMS_AND_CONDITIONS")}</PostElementTitleH2>
					<PostElementParagraph>
						<PostElementLink
							target="blank"
							href="https://assets.geneious.com/legal/terms-of-service.pdf"
						>
							{t("TERMS_AND_CONDITIONS_LINK")}
						</PostElementLink>
					</PostElementParagraph>
					<PostElementTitleH2>{t("RELEASES_UPDATES_AND_SUPPORT")}</PostElementTitleH2>
					<PostElementParagraph>{t("RELEASES_UPDATES_AND_SUPPORT_TEXT_1")}</PostElementParagraph>
					<PostElementParagraph>{t("RELEASES_UPDATES_AND_SUPPORT_TEXT_2")}</PostElementParagraph>
					<PostElementParagraph>{t("RELEASES_UPDATES_AND_SUPPORT_TEXT_3")}</PostElementParagraph>
					<PostElementParagraph>
						<Html Tag="span">
							{t("RELEASES_UPDATES_AND_SUPPORT_TEXT_4", {
								supportedOSLink:
									"https://help.geneious.com/hc/en-us/articles/360045071451-Supported-Operating-Systems",
							})}
						</Html>
					</PostElementParagraph>
					<PostElementTitleH2>{t("SUBSCRIPTION_TERMS")}</PostElementTitleH2>
					<PostElementParagraph>{t("SUBSCRIPTION_TERMS_TEXT_1")}</PostElementParagraph>
					<PostElementParagraph>{t("SUBSCRIPTION_TERMS_TEXT_2")}</PostElementParagraph>
					<PostElementUl>
						<PostElementListItem>{t("SUBSCRIPTION_TERMS_LIST_ITEM_1")}</PostElementListItem>
						<PostElementListItem>{t("SUBSCRIPTION_TERMS_LIST_ITEM_2")}</PostElementListItem>
						<PostElementListItem>{t("SUBSCRIPTION_TERMS_LIST_ITEM_3")}</PostElementListItem>
						<PostElementListItem>
							<Html Tag="span">
								{t("SUBSCRIPTION_TERMS_LIST_ITEM_4", {
									pricing: "https://www.geneious.com/pricing/",
								})}
							</Html>
						</PostElementListItem>
						<PostElementListItem>{t("SUBSCRIPTION_TERMS_LIST_ITEM_5")}</PostElementListItem>
						<PostElementListItem>{t("SUBSCRIPTION_TERMS_LIST_ITEM_6")}</PostElementListItem>
						<PostElementListItem>{t("SUBSCRIPTION_TERMS_LIST_ITEM_7")}</PostElementListItem>
						<PostElementListItem>{t("SUBSCRIPTION_TERMS_LIST_ITEM_8")}</PostElementListItem>
						<PostElementListItem>
							<Html Tag="span">
								{t("SUBSCRIPTION_TERMS_LIST_ITEM_9", {
									mailLink: "support@geneious.com",
								})}
							</Html>
						</PostElementListItem>
						<PostElementListItem>{t("SUBSCRIPTION_TERMS_LIST_ITEM_10")}</PostElementListItem>
					</PostElementUl>
					<PostElementTitleH2>{t("PRIVACY_STATEMENT_TITLE")}</PostElementTitleH2>
					<PostElementParagraph>
						<Html Tag="span">
							{t("PRIVACY_STATEMENT_TEXT", {
								salesForce: "https://www.salesforce.com",
							})}
						</Html>
					</PostElementParagraph>
					<PostElementTitleH2>{t("WHAT_INFORMATION_TITLE")}</PostElementTitleH2>
					<PostElementParagraph>{t("WHAT_INFORMATION_TEXT_1")}</PostElementParagraph>
					<PostElementParagraph>{t("WHAT_INFORMATION_TEXT_2")}</PostElementParagraph>
					<PostElementParagraph>{t("WHAT_INFORMATION_TEXT_3")}</PostElementParagraph>
					<PostElementOl>
						<PostElementListItem>{t("WHAT_INFORMATION_TEXT_4")}</PostElementListItem>
						<PostElementListItem>{t("WHAT_INFORMATION_TEXT_5")}</PostElementListItem>
						<PostElementListItem>{t("WHAT_INFORMATION_TEXT_6")}</PostElementListItem>
					</PostElementOl>
					<PostElementTitleH2>{t("WHAT_WE_DO_TITLE")}</PostElementTitleH2>
					<PostElementParagraph>{t("WHAT_WE_DO_TEXT_1")}</PostElementParagraph>
					<PostElementParagraph>{t("WHAT_WE_DO_TEXT_2")}</PostElementParagraph>
					<PostElementParagraph>{t("WHAT_WE_DO_TEXT_3")}</PostElementParagraph>
					<PostElementParagraph>{t("WHAT_WE_DO_TEXT_4")}</PostElementParagraph>
					<PostElementTitleH2>{t("CREDIT_CARD_INFO_TITLE")}</PostElementTitleH2>
					<PostElementParagraph>{t("CREDIT_CARD_INFO_TEXT")}</PostElementParagraph>
					<PostElementTitleH2>{t("REVIEW_AND_CORRECTION_INFO_TITLE")}</PostElementTitleH2>
					<PostElementParagraph>{t("REVIEW_AND_CORRECTION_INFO_TEXT")}</PostElementParagraph>
					<PostElementTitleH2>{t("SECURITY_INFO_TITLE")}</PostElementTitleH2>
					<PostElementParagraph>{t("SECURITY_INFO_TEXT")}</PostElementParagraph>
					<PostElementTitleH2>{t("FURTHER_INFO_TITLE")}</PostElementTitleH2>
					<PostElementParagraph>{t("FURTHER_INFO_TEXT_1")}</PostElementParagraph>
					<PostElementParagraph>{t("FURTHER_INFO_TEXT_2")}</PostElementParagraph>
					<PostElementTitleH2>{t("FURTHER_DETAILS_TITLE")}</PostElementTitleH2>
					<PostElementParagraph>
						<Html Tag="span">
							{t("FURTHER_DETAILS_TEXT", {
								privacyPolicyLink: "https://www.geneious.com/privacy-policy/",
							})}
						</Html>
					</PostElementParagraph>
					<PostElementTitleH2>{t("VOLUNTARY_PRODUCT_TITLE")}</PostElementTitleH2>
					<PostElementParagraph>{t("VOLUNTARY_PRODUCT_TEXT_1")}</PostElementParagraph>
					<PostElementParagraph>
						<PostElementLink href="https://www.geneious.com/vpat">
							{t("VOLUNTARY_PRODUCT_TEXT_2")}
						</PostElementLink>
					</PostElementParagraph>
					<PostElementTitleH2>{t("OPEN_SOURCE_SOFTWARE_TITLE")}</PostElementTitleH2>
					<PostElementParagraph>{t("OPEN_SOURCE_SOFTWARE_TEXT_1")}</PostElementParagraph>
					<PostElementParagraph>{t("OPEN_SOURCE_SOFTWARE_TEXT_2")}</PostElementParagraph>
					<PostElementParagraph>{t("OPEN_SOURCE_SOFTWARE_TEXT_3")}</PostElementParagraph>
					<PostElementParagraph>{t("OPEN_SOURCE_SOFTWARE_TEXT_4")}</PostElementParagraph>
					<PostElementParagraph>{t("OPEN_SOURCE_SOFTWARE_TEXT_5")}</PostElementParagraph>
					<PostElementParagraph>
						<PostElementLink href="https://assets.geneious.com/opensource/BioJava1.5-src-with-biomatters-patches.tar.gz">
							{t("OPEN_SOURCE_SOFTWARE_LINK_1")}
						</PostElementLink>
						<br />
						<PostElementLink href="https://assets.geneious.com/opensource/BioJava1.5-src.tar.gz">
							{t("OPEN_SOURCE_SOFTWARE_LINK_2")}
						</PostElementLink>
						<br />
						<PostElementLink href="https://assets.geneious.com/opensource/dynclass-src-with-biomatters-patches.zip">
							{t("OPEN_SOURCE_SOFTWARE_LINK_3")}
						</PostElementLink>
						<br />
						<PostElementLink href="https://assets.geneious.com/opensource/ViennaRNA-2.0.7.tar.gz">
							{t("OPEN_SOURCE_SOFTWARE_LINK_4")}
						</PostElementLink>
						<br />
						<PostElementLink href="https://assets.geneious.com/opensource/ViennaRNA-2.1.9.tar.gz">
							{t("OPEN_SOURCE_SOFTWARE_LINK_5")}
						</PostElementLink>
						<br />
						<PostElementLink href="https://assets.geneious.com/opensource/jcommon-1.0.16.tar.gz">
							{t("OPEN_SOURCE_SOFTWARE_LINK_6")}
						</PostElementLink>
						<br />
						<PostElementLink href="https://assets.geneious.com/opensource/jfreechart-1.0.13.zip">
							{t("OPEN_SOURCE_SOFTWARE_LINK_7")}
						</PostElementLink>
						<br />
						<PostElementLink href="https://assets.geneious.com/opensource/mauve-2-3-1-release.zip">
							{t("OPEN_SOURCE_SOFTWARE_LINK_8")}
						</PostElementLink>
						<br />
						<PostElementLink href="https://assets.geneious.com/opensource/mira-4.0-source-with-biomatters-patches.tar.bz2">
							{t("OPEN_SOURCE_SOFTWARE_LINK_9")}
						</PostElementLink>
						<br />
						<PostElementLink href="https://assets.geneious.com/opensource/primer3-2.3.7-source-with-biomatters-patches.zip">
							{t("OPEN_SOURCE_SOFTWARE_LINK_10")}
						</PostElementLink>
						<br />
						<PostElementLink href="https://assets.geneious.com/opensource/freehep-vectorgraphics-2.1.1-src.tar.gz">
							{t("OPEN_SOURCE_SOFTWARE_LINK_11")}
						</PostElementLink>
						<br />
						<PostElementLink href="https://assets.geneious.com/opensource/freehep-io-2.0.2-sources.jar">
							{t("OPEN_SOURCE_SOFTWARE_LINK_12")}
						</PostElementLink>
						<br />
						<PostElementLink href="https://assets.geneious.com/opensource/freehep-util-2.0.2-sources.jar">
							{t("OPEN_SOURCE_SOFTWARE_LINK_13")}
						</PostElementLink>
						<br />
						<PostElementLink href="https://assets.geneious.com/opensource/spades-4.0.0-win.zip">
							{t("OPEN_SOURCE_SOFTWARE_LINK_14")}
						</PostElementLink>
						<br />
						<PostElementLink href="https://assets.geneious.com/opensource/clustal-omega-1.2.3.tar.gz">
							{t("OPEN_SOURCE_SOFTWARE_LINK_15")}
						</PostElementLink>
						<br />
						<PostElementLink href="https://assets.geneious.com/opensource/mysql-connector-java-8.0.20.tar.gz">
							{t("OPEN_SOURCE_SOFTWARE_LINK_16")}
						</PostElementLink>
					</PostElementParagraph>
				</GuidePageTemplateMain>
			</GuidePageTemplate>
		</SiteLayout>
	);
};

export default Legal;
